import React, {useState, useEffect} from 'react';
import * as yup from 'yup';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useFormik } from 'formik';
import { useLoginMutation } from 'apis/authenticationApi';
import { useDispatch, useSelector } from 'react-redux';
import { tokenReceived } from 'redux/slices/authenticationSlice';
import {emptySplitApi} from "../../apis/api";

const LoginForm = ({onLoginSuccess}) => {
    const schema = yup.object({
        username: yup.string().required('Email is a required field'),
        password: yup.string().required('Password is a required field')
    });

    const [login] = useLoginMutation();
    const dispatch = useDispatch();
    const [messages, setMessages] = useState("");

    const formik = useFormik({
        initialValues: {username: '', password: ''},
        validationSchema: schema,
        onSubmit: async (data) => {
            setMessages("");

            const formData = new URLSearchParams();

            formData.append('username', data.username);
            formData.append('password', data.password);

            const results = await login(formData);

            if(results?.data?.message) {
                dispatch(emptySplitApi.util.resetApiState());
                dispatch(tokenReceived(results.data.message));

                if(onLoginSuccess) {
                    onLoginSuccess();
                }
            }
            else {
                setMessages("Email or Password Incorrect");
            }
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <form onSubmit={formik.handleSubmit} className="formgrid grid">
            <div className="col-12">
                <span className="error">{messages}</span>
            </div>
            <div className="field col-12">
                <span className="p-float-label">
                    <InputText autoComplete="username" id="username" name="username" className="inputfield w-full" value={formik.values?.username} onChange={formik.handleChange} />
                    <label htmlFor="username" className={classNames({ 'p-error': isFormFieldValid('username') })}>Email</label>
                </span>
                {getFormErrorMessage('username')}
            </div>
            <div className="field col-12">
                <span className="p-float-label">
                    <Password autoComplete="current-password" feedback={false} id="password" name="password" className="inputfield w-full" toggleMask value={formik.values?.password} onChange={formik.handleChange} />
                    <label htmlFor="password" className={classNames({ 'p-error': isFormFieldValid('password') })}>Password</label>
                </span>
                {getFormErrorMessage('password')}
            </div>
            <div className="field col-12">
                <Button type="submit" label="Login" />
            </div>
        </form>
    );
}

export default LoginForm;